import WelcomeSection from "@/pages/dashboard/components/WelcomeSection";
import StatCards from "@/pages/dashboard/components/StatCards";
import BranchesRow from "@/pages/dashboard/components/BranchesRow";
import ActiveOrders from "@/pages/dashboard/components/ActiveOrders";

export default function DashboardHome() {
  return (
    <div className="flex flex-col gap-6">
      <WelcomeSection />
      <StatCards />
      <BranchesRow />
      <ActiveOrders />
    </div>
  );
}